import React, { useState, useEffect } from 'react';
// Component moved from root console directory to data-management subdirectory
const ImageCenter: React.FC = () => {
  return <div>Image Center - Component moved to data-management directory</div>;
};

export default ImageCenter;
